import { render } from "./ServerWillBeOffNotificationModal.vue?vue&type=template&id=5f5a4e15"
import script from "./ServerWillBeOffNotificationModal.vue?vue&type=script&lang=js"
export * from "./ServerWillBeOffNotificationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__